import { useEffect, useState } from 'react';
import { Business } from '@/features/availability/types';
import BusinessIcon from '@/assets/img/business.png';
import { ReactComponent as GlobeIcon } from '@/assets/img/v2/globe-v2.svg';

import { ReactComponent as AddressIcon } from '@/assets/img/v2/address-icon.svg';
import { ReactComponent as PhoneIcon } from '@/assets/img/v2/phone-icon.svg';

import { ReactComponent as LinkIcon } from '@/assets/img/v2/redirect-link.svg';
import { ReactComponent as InfoIcon } from '@/assets/img/v2/info-icon.svg';
import { useTranslation } from 'react-i18next';

import './PetStoreCard.scss';
export type PetStoreCardProps = {
  petStore: Business;
  onStoreLinkClick: (item: Business) => void;
  onStoreClick: (item: Business) => void;
};
export const PetStoreCard = ({ petStore, onStoreLinkClick, onStoreClick }: PetStoreCardProps) => {
  const onItemClick = () => {
    onStoreClick(petStore);
  };
  const onLinkClick = (e:any) => {
    e.stopPropagation();
    onStoreLinkClick(petStore);
  };
  const openWebsite = (e:any) => {
    e.stopPropagation();
    const url = petStore.website.match(/^https?:/) ? petStore.website : '//' + petStore.website;
    window.open(url, '_blank')
  }
  const { t } = useTranslation();
  return (
    <div className="pet-store-card" onClick={onItemClick}>
      <InfoIcon className='info-icon' />
      <span className="image-holder">
        <img
          className="store-logo"
          src={petStore.businessImageUrl ? petStore.businessImageUrl : BusinessIcon}
        />
        {petStore.website && <GlobeIcon onClick={(e) => openWebsite(e)} />}
      </span>
      <h5 className="name">{petStore.name}</h5>
      <span className={`store-details ${petStore.address ? '' : 'hide'}`}>
        <AddressIcon />
        <p className="link" title={petStore.address}>
          {petStore.address}
        </p>
        <LinkIcon className="link" />
      </span>
      <span className={`store-details last ${petStore.phone ? '' : 'hide'}`}>
        <PhoneIcon />
        <p title={petStore.address}>{petStore.phone}</p>
      </span>

      <div className="action">
        <button type="button" onClick={(e) => onLinkClick(e)} className="petsked-button button-white">
          {t('Book Appointment')}
        </button>
      </div>
    </div>
  );
};
